import React from 'react'
import { getAllProduct } from '../../hooks/useShoppingCart'
import ShoppingCartComponent from '../../components/ShoppingCartComponent'

function ShoppingCart() {
  return <ShoppingCartComponent />
}

export default ShoppingCart
